
import React from 'react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      title: "OSHA Safety Consulting",
      description: "We provide expert guidance on all aspects of OSHA compliance, helping you manage your safety program, conduct physical site audits, and develop necessary safety documentation.",
      details: "We  offer OSHA safety compliance services for clients of all sizes, from owner-operated businesses to Fortune 500 corporations. We can manage all or part of your safety program, providing safety documentation, physical site audits, safety training, safety staffing, and program management."
    },
    {
      title: "OSHA Safety Training",
      description: "Our consultants are experienced OSHA Outreach Trainers who will work directly with you to develop a comprehensive safety training program that ensures your team has the OSHA training they need to work safely.",
      details: "Health and Safety Courses are available at our safety training facility, yours, or even at your job site. Visit our 'Safety Training' page for a complete list of safety courses and our open-enrollment safety training calendar."
    },
    {
      title: "Facility and Site Assessments",
      description: "Our OSHA compliance consultants will travel to your facility or construction site for a complete site safety assessment.",
      details: "Our comprehensive site safety inspection will identify violative conditions and non-compliant employee behaviors and document compliance with OSHA regulations. We can assist in implementing corrective actions, significantly decreasing losses from worker injuries and associated costs, including lawsuits, and identifying training gaps."
    },
    {
      title: "Written Health and Safety Programs",
      description: "We write customized safety and health programs for each client and update them as regulations change.",
      details: "We can provide you with an entire program or update the one you currently have in place. Whether you are looking for basic OSHA compliance or best-in-class safety programs, we can help you develop safety manuals, JHAs, risk assessments, Pre-Task Plans, Site–Specific Safety Plans, and SOPs designed with your organizational goals in mind."
    },
    {
      title: "DOT / Fleet Safety Programs",
      description: "Fleet Safety Programs are more critical than ever with the constant pressure of more vehicles on the road.",
      details: "Our consultants are experienced in the transportation industry and can work with you to address FMCSA and DOT regulatory issues that companies face daily."
    },
    {
      title: "OSHA Citation Defense",
      description: "We work with our clients to navigate OSHA inspections, respond with proper documentation, participate in the informal conference process, abate citations issued, and navigate contesting citations when warranted.",
      details: "Partnering with a company that understands the process and has demonstrated success can mean the difference between a clean record and a legacy of citations. In the competitive environment that most businesses face, a demonstrated safety record, clear of OSHA citations, can be critical to win new business and provide companies with a competitive advantage."
    },
    {
      title: "Workers Compensation Claims Management",
      description: "Managing worker injuries is an important part of the claim process that is often overlooked.",
      details: "From ensuring that injured workers receive the care they need to verifying that the physicians treating them understand your organization's return to work requirements and your light duty program, we can manage employee compensation claims from the first injury report to release to full duty."
    },
    {
      title: "Safety Staffing",
      description: "We offers a full complement of safety professionals available for work on projects anywhere in the US.",
      details: "We staff short and long-term projects for construction and general industry, including manufacturing and distribution environments. Our team will ensure that we understand the requirements for the professional and then match the right candidate to your project and your team."
    }
  ];

  return (
    <section id="services" className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">
            Our Services
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              OSHA Safety Consulting
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              We provide expert guidance on all aspects of OSHA compliance, helping you manage your safety program, conduct physical site audits, and develop necessary safety documentation.
            </p>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://safetyconsultantsusa.com/wp-content/uploads/2024/08/osha-consulting-services.jpg"
              alt="OSHA Consulting Services"
              className="rounded-lg shadow-lg max-w-full h-auto"
            />
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                {service.description}
              </p>
              <p className="text-gray-600 text-sm leading-relaxed">
                {service.details}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="#contact-form" 
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
